// extracted by mini-css-extract-plugin
module.exports = {"countDown":"CountDown_countDown__1qfN2","times":"CountDown_times__SBArX","time":"CountDown_time__1dztB"};